<template>
  <div class="toggle-custom-menu-effect">
    <case-logic-label>Custom menu</case-logic-label>
    <md-field>
      <md-select
        v-model="state.effect.id"
        v-close-on-zoom
        class="grandparent-select"
        :disabled="readonly"
        @md-selected="selectGrandparent"
      >
        <md-option
          v-for="button in grandParentButtons"
          :key="button.value"
          :value="button.value"
        >
          {{ button.label }}
        </md-option>
      </md-select>
    </md-field>
    <case-logic-label v-show="false">Test</case-logic-label>
    <case-logic-label>Parent button</case-logic-label>
    <div class="parent-container">
      <md-field>
        <md-select
          v-model="state.effect.parentId"
          v-close-on-zoom
          class="parent-select"
          placeholder="select parent button"
          :disabled="readonly || !parentButtons.length"
          @md-selected="selectParent"
        >
          <md-option
            v-for="button in parentButtons"
            :key="button.value"
            :value="button.value"
          >
            {{ button.label }}
          </md-option>
        </md-select>
      </md-field>
      <help-tooltip v-if="parentButtonError" :show-space="false" type="error">
        <span>{{ parentButtonError.message }}</span>
      </help-tooltip>
    </div>
    <case-logic-label>Child button</case-logic-label>
    <div class="child-container">
      <md-field>
        <md-select
          v-model="state.effect.childId"
          v-close-on-zoom
          class="child-select"
          :disabled="readonly || !childButtons.length"
          @md-selected="selectChild"
        >
          <md-option
            v-for="button in childButtons"
            :key="button.value"
            :value="button.value"
          >
            {{ button.label }}
          </md-option>
        </md-select>
      </md-field>
      <help-tooltip v-if="childButtonError" :show-space="false" type="error">
        <span>{{ childButtonError.message }}</span>
      </help-tooltip>
    </div>
    <div v-if="childSelected" class="apply-container">
      <md-checkbox
        :value="state.effect.applyToParent"
        :disabled="readonly"
        @change="selectApplyToParent"
      >
        Also {{ type === 'ENABLE' ? 'enable' : 'disable' }} parent
      </md-checkbox>
    </div>
  </div>
</template>

<script>
import HelpTooltip from '~lib/common/components/HelpTooltip';
import CaseLogicLabel from './common/CaseLogicLabel.vue';
import nodeMixins from './mixins/NodeMixins';

export default {
  name: 'toggle-custom-menu-effect',
  components: {
    HelpTooltip,
    CaseLogicLabel
  },
  mixins: [ nodeMixins ],
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'type',
  ],
  data() {
    return {
      grandParentButtons: [
        { value: 'ASSESS', label: 'Assess' },
        { value: 'MONITOR', label: 'Monitor' },
        { value: 'TREAT', label: 'Treat' },
      ],
      state: {
        effect: {
          id: 'ASSESS',
          parentId: null,
          childId: null,
          applyToParent: true,
        },
      },
    };
  },
  computed: {
    customMenus() {
      return this.emitter.caseConf.customMenus || [];
    },
    parentButtons() {
      const grandParentMenu = this.customMenus.find(menu => menu.category === this.state.effect.id);
      if (!grandParentMenu) {
        return [];
      }
      const buttons = grandParentMenu.items.map(item => ({
        value: item.id,
        label: item.content.en
      }));
      if (this.state.effect.parentId && !grandParentMenu.items.find(item => item.id === this.state.effect.parentId)) {
        buttons.push({ value: this.state.effect.parentId, label: '-- not found --' });
      }
      return buttons;
    },
    childItems() {
      const grandParentMenu = this.customMenus.find(menu => menu.category === this.state.effect.id);
      if (!grandParentMenu) {
        return [];
      }
      const parentMenu = grandParentMenu.items.find(item => item.id === this.state.effect.parentId);
      if (!parentMenu) {
        return [];
      }
      return parentMenu.children;
    },
    childButtons() {
      const buttons = this.childItems.map(item => ({
        value: item.id,
        label: item.content.en
      }));
      if (!buttons.length) {
        return [];
      }
      if (this.state.effect.childId && !buttons.find(item => item.value === this.state.effect.childId)) {
        buttons.push({ value: this.state.effect.childId, label: '-- not found --'});
      }
      buttons.push({ value: undefined, label: '-- clear --' });
      return buttons;
    },
    childSelected() {
      return !!this.state.effect.childId;
    },
    parentButtonError() {
      return this.errors.find(error => error.metadata.errorId === 'customMenuParent');
    },
    childButtonError() {
      return this.errors.find(error => error.metadata.errorId === 'customMenuChild');
    },
  },
  mounted() {
    this.syncState();
    this.update();
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      if (data) {
        this.state.effect.id = data.id;
        this.state.effect.parentId = data.parentId;
        this.state.effect.childId = data.childId;
        this.state.effect.applyToParent = data.applyToParent;
      }
    },
    selectGrandparent(value) {
      this.state.effect.id = value;
      this.state.effect.parentId = null;
      this.state.effect.childId = null;
      this.update();
    },
    selectParent(value) {
      this.state.effect.parentId = value;
      this.state.effect.childId = null;
      this.update();
    },
    selectChild(value) {
      this.state.effect.childId = value;
      this.update();
    },
    selectApplyToParent(value) {
      this.state.effect.applyToParent = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'CUSTOM_MENU',
        ...this.state.effect,
        value: this.type === 'ENABLE',
      });
      this.emitter.trigger('process', this.control);
    },
  }
}
</script>

<style scoped>
.toggle-custom-menu-effect {
  display: grid;
  grid-template-columns: auto 1fr;
}
.parent-container,
.child-container {
  display: flex;
}
.md-field {
  margin: 0;
}
.md-select >>> .md-input {
  height: 36px;
}
.md-checkbox {
  margin: 6px 6px 6px 0;
}
</style>